export default {
  Actions: {
    FETCH_DEFAULT_TEMPLATES_SUCCESS: 'updateAiSettings/FETCH_DEFAULT_TEMPLATES_SUCCESS',
    CREATE_UPDATE_AI_SETTING_SUCCESS: 'updateAiSettings/CREATE_UPDATE_AI_SETTING_SUCCESS',
    FETCH_UPDATE_AI_SETTING_SUCCESS: 'updateAiSettings/FETCH_UPDATE_AI_SETTING_SUCCESS',
    UPDATE_UPDATE_AI_SETTING_SUCCESS: 'updateAiSettings/UPDATE_UPDATE_AI_SETTING_SUCCESS',
    CREATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS: 'updateAiSettings/CREATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS',
    UPDATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS: 'updateAiSettings/UPDATE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS',
    REMOVE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS: 'updateAiSettings/REMOVE_UPDATE_AI_TEMPLATE_SECTION_SUCCESS',
    CREATE_UPDATE_AI_REPORT_SECTIONS_SUCCESS: 'updateAiSettings/CREATE_UPDATE_AI_REPORT_SECTIONS_SUCCESS',
    CATCH_UPDATE_AI_SOCKET_SUCCESS: 'updateAiSettings/CATCH_UPDATE_AI_SOCKET_SUCCESS',
    ADD_CURRENTLY_GENERATING_SECTION_SLUGS: 'updateAiSettings/ADD_CURRENTLY_GENERATING_SECTION_SLUGS',
    REMOVE_CURRENTLY_GENERATING_SECTION_SLUGS: 'updateAiSettings/REMOVE_CURRENTLY_GENERATING_SECTION_SLUGS',
    REMOVE_CURRENTLY_GENERATING_SECTION_SLUG: 'updateAiSettings/REMOVE_CURRENTLY_GENERATING_SECTION_SLUG',
    UPDATE_UPDATE_AI_SETTING_REPORT_SUCCESS: 'updateAiSettings/UPDATE_UPDATE_AI_SETTING_REPORT_SUCCESS',
    FETCH_UPDATE_AI_REPORT_SUCCESS: 'updateAiSettings/FETCH_UPDATE_AI_REPORT_SUCCESS',
    FETCH_UPDATE_AI_REPORTS_SUCCESS: 'updateAiSettings/FETCH_UPDATE_AI_REPORTS_SUCCESS',
    DELETE_UPDATE_AI_SETTING_REPORT_SUCCESS: 'updateAiSettings/DELETE_UPDATE_AI_SETTING_REPORT_SUCCESS',
  },
  State: {
    TEMPLATE_BY_TEMPLATE_SLUG: 'TEMPLATE_BY_TEMPLATE_SLUG',
    UPDATE_AI_SETTINGS_BY_SLUG: 'UPDATE_AI_SETTINGS_BY_SLUG',
    TEMPLATE_SECTIONS_BY_SLUG: 'TEMPLATE_SECTIONS_BY_SLUG',
    REPORTS_BY_REPORT_SLUG: 'REPORTS_BY_REPORT_SLUG',
    CURRENTLY_GENERATING_SECTION_SLUGS: 'CURRENTLY_GENERATING_SECTION_SLUGS',
  },
};
